module.exports = __webpack_public_path__ + "static/media/hero__league-index.7cadf556.jpg";